import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import * as selector from "../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../common/selectors/onlineRenewal";
import * as onlineRenewalAction from "../../../../common/actions/onlineRenewal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../../assets";
import CustomBoardSelectEnrolment from "../../../components/CustomBoardSelectEnrolment";

const policyInfo = {
  policyNo: "M0001033",
  productName: "Commercial Motor",
  startDate: "31/08/2020",
  endDate: "30/09/2020",
  renewalPremium: "1,343.15",
};

class SelectEnrolmentAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localOrderNo: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { checkRenewabilityData } = this.props;

    const policyNo = onlineRenewalSelector.checkRenewabilityDataPolicyNumber(
      checkRenewabilityData
    );
    const orderNo = onlineRenewalSelector.checkRenewabilityDataOrderNumber(
      checkRenewabilityData
    );
    const nric = onlineRenewalSelector.checkRenewabilityDataNric(
      checkRenewabilityData
    );
    const premium = onlineRenewalSelector.checkRenewabilityDataPremium(
      checkRenewabilityData
    );
    const isRecurring = onlineRenewalSelector.checkRenewabilityDataIsRecurring(
      checkRenewabilityData
    );
    const product = onlineRenewalSelector.checkRenewabilityDataProduct(
      checkRenewabilityData
    );
    const coveragePeriod = onlineRenewalSelector.checkRenewabilityDataCoveragePeriod(
      checkRenewabilityData
    );
    const statusLabel = onlineRenewalSelector.checkRenewabilityDataStatusLabel(
      checkRenewabilityData
    );
    const msg = onlineRenewalSelector.checkRenewabilityDataMessage(
      checkRenewabilityData
    );
    const showRecurringPaymentCheckBox = onlineRenewalSelector.checkRenewabilityDataShowRecurringPaymentCheckBox(
      checkRenewabilityData
    );

    this.setState({
      localPolicyNo: policyNo,
      localOrderNo: orderNo,
      localNric: nric,
      localPremium: premium,
      localIsRecurring: isRecurring,
      localProduct: product,
      localCoveragePeriod: coveragePeriod,
      localStatusLabel: statusLabel,
      localMsg: msg,
      localShowRecurringCheckBox: showRecurringPaymentCheckBox,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = () => {
    const { history } = this.props;
    const {
      renewalPayNowLoading,
      renewalPayNowData,
      renewalPayNowStatus,
    } = this.props;
    if (
      renewalPayNowLoading === false &&
      renewalPayNowData !== null &&
      renewalPayNowStatus === true
    ) {
      const paymentModel = onlineRenewalSelector.renewalPayNowDataPaymentModel(
        renewalPayNowData.Data
      );
      const amount = onlineRenewalSelector.renewalPayNowDataAmount(
        paymentModel
      );
      const email = onlineRenewalSelector.renewalPayNowDataEmail(paymentModel);
      const apiName = onlineRenewalSelector.renewalPayNowDataAPIName(
        paymentModel
      );
      const key = onlineRenewalSelector.renewalPayNowDataKey(paymentModel);
      const payMode = onlineRenewalSelector.renewalPayNowDataPayMode(
        paymentModel
      );
      const notifyURL = onlineRenewalSelector.renewalPayNowDataNotifyURL(
        paymentModel
      );
      const txnID = onlineRenewalSelector.renewalPayNowDataTxnId(paymentModel);
      const isRecurring = onlineRenewalSelector.renewalPayNowDataIsRecurring(
        paymentModel
      );
      const statusLabel = onlineRenewalSelector.checkRenewabilityDataStatusLabel(
        renewalPayNowData.Data
      );
      const paymentUrl = onlineRenewalSelector.renewalPayNowDataPaymentUrl(
        renewalPayNowData.Data
      );
      const returnUrl = onlineRenewalSelector.renewalPayNowDataReturnURL(
        paymentModel
      );

      if (statusLabel === "Renewal Unsuccessful") {
        history.push("/PayRenewalUnsuccessful");
      } else {
        let form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", paymentUrl);
        let field = [
          { name: "amount", value: amount },
          { name: "email", value: email },
          { name: "APIName", value: apiName },
          {
            name: "key",
            value: key,
          },
          { name: "payMode", value: payMode },
          {
            name: "returnURL",
            value: returnUrl,
          },
          { name: "notifyURL", value: notifyURL },
          { name: "txnId", value: txnID },
          { name: "isRecurring", value: isRecurring },
        ];
        for (let i = 0; i < field.length; i++) {
          let hf = document.createElement("input");
          hf.setAttribute("type", "hidden");
          hf.setAttribute("name", field[i].name);
          hf.setAttribute("value", field[i].value);
          form.appendChild(hf);
        }
        document.body.appendChild(form);
        form.submit();
        this.setState({ loadingToReddot: true });
      }
    }
  };

  onClickPayRenewal = () => {
    const { renewalPayNow } = this.props;

    const {
      localPremium,
      localOrderNo,
      localNric,
      localPolicyNo,
      localIsRecurring,
    } = this.state;

    if (localPremium === "$0.00") {
      window.history.back();
    } else {
      renewalPayNow(
        localPremium,
        localOrderNo,
        localNric,
        localPolicyNo,
        localIsRecurring
      );
    }
  };

  onClickLetGo = () => {
    //this.onClickPayRenewal();
    this.props.history.push("/EnrolGiro");
  };

  onClickEnrolNow = () => {
    this.props.history.push("/EnrolmentStatus");
  };

  onClickHere = () => {};

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  renderChildren = () => {
    const { classes } = this.props;
    const {
      policyNo,
      productName,
      startDate,
      endDate,
      renewalPremium,
    } = policyInfo;
    const {
      localPolicyNo,
      localOrderNo,
      localNric,
      localPremium,
      localIsRecurring,
      localCoveragePeriod,
      localProduct,
      localStatusLabel,
      localMsg,
      loadingToReddot,
      isSwitchFundSuccess = true,
      switchFundMessage = "abc",
    } = this.state;
    return (
      <Grid
        container
        //direction={"column"}
        // justify={"center"}
        //  alignItems={"center"}
        //style={{ marginTop: "7em", paddingLeft: "15em", paddingRight: "15em" }}
      >
        <Grid item>
          <Grid
            container
            //direction={"column"}
            //justify={"center"}
            //alignItems={"center"}
          >
            <Grid item>
              <CustomText design={classes.titleStyle}>
                Select enrolment account
              </CustomText>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CustomPaper design={classes.submitPaper}>
            <Grid
              container
              direction={"column"}
              justify={"center"}
              alignItems={"left"}
              spacing={1}
              style={{ padding: 25 }}
            >
              <Grid container style={{ justifyContent: "space-between" }}>
                <Grid item style={{display:"inline-block"}}>
                  <CustomText design={classes.titleDialogTextStyle}>
                    <span className={classes.boldStyle}>Note:</span> This
                    authorization will remain in force until:
                  </CustomText>
                </Grid>
                <Grid item  style={{display:"inline-block"}}>
                  <img src={Image.dbsLogo} className={classes.imageStyle} />
                </Grid>
              </Grid>
              {/* <Grid item>
                <CustomText design={classes.titleDialogTextStyle}>
                  Note: This authorization will remain in force until:
                </CustomText>
              </Grid> */}
              <Grid item style={{ marginLeft: 10 }}>
                <CustomText design={classes.titleDialogTextStyle}>
                  <span style={{ marginRight: 5 }}> &#8226;</span> DBS's written
                  notice is sent to your address last known to DBS;
                </CustomText>
              </Grid>
              <Grid item style={{ marginLeft: 10 }}>
                <CustomText design={classes.titleDialogTextStyle}>
                  <span style={{ marginRight: 5 }}> &#8226;</span> upon DBS's
                  receipt of your written revocation;or
                </CustomText>
              </Grid>
              <Grid item style={{ marginLeft: 10 }}>
                <CustomText design={classes.titleDialogTextStyle}>
                  <span style={{ marginRight: 5 }}> &#8226;</span> upon DBS's
                  receipt of the notice of expiry from Etiqa
                </CustomText>
              </Grid>
              <Grid item style={{ marginTop: 20, marginBottom: 15 }}>
                <CustomText design={classes.boldStyle}>
                  GIRO Enrolment Reference No:
                </CustomText>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomTextInput
                  title={"Select DBS/POSB account to enrol"}
                  textstyle={classes.labelTextInputTextStyle}
                  design={classes.textInputContainer}
                  fullWidth={true}
                  // value={`${startDate} ~ ${endDate}`}
                  value={"0213452762"}
                  //disabled={true}
                />
              </Grid>
            </Grid>
          </CustomPaper>
          <Grid container style={{ justifyContent: "space-between" }}>
            <Grid>
              <CustomButton
                title={"Cancel"}
                design={classes.backButton}
                textstyle={classes.backButtonTextStyle}
                onClick={this.onClickLetGo}
              />
            </Grid>
            <Grid>
              <CustomButton
                title={"Enrol Now"}
                design={classes.letGoButtonStyle}
                textstyle={classes.buttonTextStyle}
                onClick={this.onClickEnrolNow}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoardSelectEnrolment
          children={this.renderChildren()}
          height={window.innerWidth < 600 ? height + 200 : height}
          width={width}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    "&$checked": {
      color: "#1858b9",
    },
  },
  imageStyle: {
    marginTop:window.innerWidth < 600  ? "0.1em" : "-0.5em"
  },
  labelTextInputTextStyle: {
    ...getFontWeight("300"),
    ...getFontSize("small"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 10,
  },
  letGoButtonStyle: {
    //width: 120,
    marginTop: 20,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "center",
    color: "#2c3034",
    marginBottom: 10,
  },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
  submitPaper: {
    //margin: 20,
    border: "1px solid #C5C5C5",
    borderRadius: " 0",
  },
  failurePaymentPaper: {
    margin: 20,
    [theme.breakpoints.between("sm", "md")]: {
      width: 600,
    },
    [theme.breakpoints.up("lg")]: {
      width: 800,
    },
  },
  appBar: {
    background:
      "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
  },
  titleStyle: {
    fontSize: "22px",
    ...getFontWeight("800"),
    marginBottom: 20,
  },
  backButton: {
    //width: 120,
    marginTop: 20,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  titleDialogTextStyle: {
    ...getFontWeight("600"),
  },
  boldStyle: {
    fontWeight: "800",
  },
});

function mapStateToProps(state) {
  return {
    checkRenewabilityData: selector.checkRenewabilityData(state),
    checkRenewabilityLoading: selector.checkRenewabilityLoading(state),
    checkRenewabilityStatus: selector.checkRenewabilityStatus(state),
    renewalPayNowData: selector.renewalPayNowData(state),
    renewalPayNowLoading: selector.renewalPayNowLoading(state),
    renewalPayNowStatus: selector.renewalPayNowStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkRenewability: (submitData) =>
      dispatch(onlineRenewalAction.checkRenewability(submitData)),
    renewalPayNow: (premium, orderNo, nric, policyNo, isRecurring) =>
      dispatch(
        onlineRenewalAction.renewalPayNow(
          premium,
          orderNo,
          nric,
          policyNo,
          isRecurring
        )
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(SelectEnrolmentAccount)));
